
/* injects from baggage-loader */

import Helpers from "../helperFunctions";

export const handleGameListMatchOfTheDaySubscriptionData = (data) => {
    let Sports = Helpers.objectToArray(data.sport),
        Games = {};
    Sports.forEach(sport => {
        if (sport) {
            Helpers.objectToArray(sport.region).forEach(region => {
                if (region) {
                    Helpers.objectToArray(region.competition).forEach(comp => {
                        if (comp) {
                            Helpers.objectToArray(comp.game).forEach(game => {
                                if (game) {
                                    Games[game.id] = {
                                        ...game,
                                        region,
                                        competition: comp,
                                        sportAlias: sport.alias,
                                        alias: sport.alias,
                                        sportName: sport.name
                                    };
                                }
                            });
                        }
                    });
                }
            });
        }
    });
    return Games;
};